import GameStateControl from "../../GameStateControl.js";
import Totals from "../../model/crew/Totals";
import BigNum from "../../model/math/BigNum";
import NumberFormatter from "../../util/NumberFormatter";
import Page from "../framework/Page";
import View from "../framework/View";
import { PageIds } from "../PageIds";

export default class PrestigePopupView extends View {
    /**
     * 
     * @param {string} parentId 
     * @param {Totals} totals 
     * @param {GameStateControl} gameStateControl
     */
    constructor(parentId, totals, gameStateControl) {
        super(parentId, PageIds.PRESTIGE_POPUP);

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {GameStateControl}
         */
        this.gameStateControl = gameStateControl;

        /**
         * @type {HTMLElement}
         */
        this.prestigeContainer = null;
        /**
         * @type {HTMLElement}
         */
        this.confirmContainer = null;

        /**
         * @type {HTMLElement}
         */
        this.prestigeEarnedInfo = null;
        /**
         * @type {HTMLElement}
         */
        this.prestigeEarnedInfo2 = null;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedPrestige = new BigNum(0);

    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        const prestigePopup = Page.createElement('div', parentElement, this.getElementId(), 'popup-window-prestige');

        const container = Page.createElement('div', prestigePopup, null, null);

        ////////////////////////////////////////
        // Header
        ////////////////////////////////////////

        const header = Page.createElement('div', container, null, 'popup-window-header');
        header.innerHTML = 'Prestige';

        const thisRef = this;

        header.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };

        ////////////////////////////////////////
        // Content
        ////////////////////////////////////////

        const sectionBody = Page.createElement('div', container, null, 'menu-section-body');

        this.prestigeContainer = Page.createElement('div', sectionBody, null, null);
        
        this.confirmContainer = Page.createElement('div', sectionBody, null, null);
        this.confirmContainer.style.display = 'none';

        // Prestige and start over at the surface.
        //
        // You will earn [xxxxx] points.
        //
        // Spend your points on skills in the skill tree.
        //
        // [Prestige]

        //////////////////////////////////////////
        // Main Prestige Content
        //////////////////////////////////////////
                
        const prestigeInfo1 = Page.createElement('div', this.prestigeContainer, null, 'prestige-info');
        prestigeInfo1.innerHTML = 'Prestige the game and start over at the surface.';

        this.prestigeEarnedInfo = Page.createElement('div', this.prestigeContainer, null, 'prestige-info');
        this.prestigeEarnedInfo.innerHTML = this.getEarnedPrestigeText();
        this.displayedPrestige.copy(this.totals.unclaimedPrestige);

        const prestigeInfo2 = Page.createElement('div', this.prestigeContainer, null, 'prestige-info');
        prestigeInfo2.innerHTML = 'You earn 1 prestige point per terrain layer cleared.';

        const prestigeInfo3 = Page.createElement('div', this.prestigeContainer, null, 'prestige-info');
        prestigeInfo3.innerHTML = 'Spend your points on skills in the skill tree.';

        const prestigeButtonRow = Page.createElement('div', this.prestigeContainer, null, 'save-popup-button-row');

        const prestigeButton1 = Page.createElement('div', prestigeButtonRow, 'prestigeButton', 'game-button prestige-button');
        prestigeButton1.style.marginTop = '10px';
        prestigeButton1.innerHTML = 'Prestige Game';

        prestigeButton1.onclick = function () {
            thisRef.displayConfirmation();
            return false;
        };

        //////////////////////////////////////////
        // Confirm Content
        //////////////////////////////////////////

        const confirmInfo1 = Page.createElement('div', this.confirmContainer, null, 'prestige-info');
        confirmInfo1.innerHTML = 'Prestige Confirmation';

        const confirmInfo2 = Page.createElement('div', this.confirmContainer, null, 'prestige-info');
        confirmInfo2.innerHTML = 'If you prestige you will be placed back on the surface.';

        const confirmInfo3 = Page.createElement('div', this.confirmContainer, null, 'prestige-info');
        confirmInfo3.innerHTML = 'Your ore and mine power will be reset.';

        const confirmInfo4 = Page.createElement('div', this.confirmContainer, null, 'prestige-info');
        confirmInfo4.innerHTML = 'Your can spend points to expand your crew and learn skills.';

        this.prestigeEarnedInfo2 = Page.createElement('div', this.confirmContainer, null, 'prestige-info');
        this.prestigeEarnedInfo2.innerHTML = this.getEarnedPrestigeText();


        const confirmButtonRow = Page.createElement('div', this.confirmContainer, null, 'save-popup-button-row');

        const cancelButton = Page.createElement('div', confirmButtonRow, 'cancelButton', 'game-button prestige-button');
        cancelButton.style.marginTop = '10px';
        cancelButton.innerHTML = 'Cancel';

        cancelButton.onclick = function () {
            thisRef.onPrestigeCancel();
            return false;
        };

        const prestigeButton2 = Page.createElement('div', confirmButtonRow, 'realPrestigeButton', 'game-button prestige-button');
        prestigeButton2.style.marginTop = '10px';
        prestigeButton2.innerHTML = 'Prestige Game';

        prestigeButton2.onclick = function () {
            thisRef.gameStateControl.prestigeGame();
            return false;
        };


        this.setInitialVisibility(false);

        super.initializeView();
    }


    /**
     * @private
     * @returns {string}
     */
    getEarnedPrestigeText() {
        return 'Prestige points earned: ' + NumberFormatter.formatBigNum(this.totals.unclaimedPrestige);
    }

    /**
     */
    displayConfirmation() {
        // Hide the save button container.
        Page.hideElement(this.prestigeContainer);

        // Show the confirmation container
        Page.showElement(this.confirmContainer);
    }

    onPrestigeCancel() {
        // Hide the confirmation container.
        Page.hideElement(this.confirmContainer);

        // Show the prestige container
        Page.showElement(this.prestigeContainer);
    }

    /**
     * @override
     */
    updateViewContents() {
        const prestige = this.totals.unclaimedPrestige;

        if (!this.displayedPrestige.equals(prestige)) {
            this.displayedPrestige.copy(prestige);

            const earnedPrestigeText = this.getEarnedPrestigeText();

            this.prestigeEarnedInfo.innerHTML = earnedPrestigeText;
            this.prestigeEarnedInfo2.innerHTML = earnedPrestigeText;
        }
    }

}